<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1200" scrollable>
			<v-card>
				<v-card-title class="text-h6">Data Riwayat Stok Stockist {{stockistName}} ({{stockistCode}})</v-card-title>
				<v-card-text>
					<StockistStockLog v-if="dialog" asDetail :filterDetail="[filterProduct, filterStockist]"></StockistStockLog>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import StockistStockLog from '../StockistStockLog'
export default {
	components: {
		StockistStockLog
	},
	data () {
		return {
			dialog: false,
			stockistName: '',
			stockistCode: '',
			params: {},
			filterProduct: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'product_code'
			},
			filterStockist: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'stockist_network_id'
			}
		}
	},
	methods: {
		async showModal(data) {
			this.filterProduct.value = data.product_code
			this.filterStockist.value = data.stockist_network_id
			this.params = data
			this.dialog = true
			this.stockistName = data.stockist_name
			this.stockistCode = data.stockist_code
		},
		hideModal() {
			this.dialog = false
		},
	},
	watch: {
	},
	created() {
	}
}
</script>
